import React from 'react';
import { Field, Form, Formik } from 'formik';
import * as yup from 'yup';

import { Button, FModal, TextInput } from '@components';
import { deParaAnexos } from './DeParaAnexos';

export const AnexosPendentesForm = ({
  isOpen,
  onClose,
  onSubmit,
  anexosPendentes,
}) => {
  const yupRules = anexosPendentes.reduce((prev, current) => {
    return { ...prev, [`anexo${current.TipoAnexo}`]: yup.mixed().required() };
  }, {});

  const motivo =
    anexosPendentes.find((anexo) => !!anexo.motivo)?.motivo || null;

  return (
    <FModal isOpen={isOpen} close widthAuto onClose={onClose}>
      {motivo && (
        <>
          <p className="mb-2">Motivo(s): </p>
          {motivo.split(';').map((m) => (
            <p key={m} className="mb-2">
              {m};
            </p>
          ))}
        </>
      )}
      <Formik
        validateOnMount
        validationSchema={yup.object({
          ...yupRules,
        })}
        initialValues={{ anexoComplementar: null }}
        onSubmit={(value, { resetForm }) => {
          onSubmit(value);

          resetForm();
        }}
      >
        {({ isValid, handleSubmit }) => {
          return (
            <Form className="mt-4">
              {anexosPendentes.map((anexo) => {
                return (
                  <Field
                    key={anexo}
                    className="mb-3"
                    name={`anexo${anexo.TipoAnexo}`}
                    type="file"
                    label={deParaAnexos[anexo.TipoAnexo]}
                    accept="image/*,.pdf"
                  >
                    {({ form }) => {
                      return (
                        <TextInput
                          className="mb-3"
                          name={`anexo${anexo.TipoAnexo}`}
                          type="file"
                          label={deParaAnexos[anexo.TipoAnexo]}
                          accept="image/*,.pdf"
                          onChange={(e) => {
                            form.setFieldTouched(`anexo${anexo.TipoAnexo}`);
                            form.setFieldValue(
                              `anexo${anexo.TipoAnexo}`,
                              e.target.value ? e.currentTarget.files : null
                            );
                          }}
                        />
                      );
                    }}
                  </Field>
                );
              })}

              <hr className="mt-32 mt-xs-0 mb-32" />
              <div className="row">
                <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                  <div className="d-block d-md-flex align-items-center">
                    <Button
                      disabled={!isValid}
                      className="ms-0 ms-md-3"
                      onClick={handleSubmit}
                    >
                      Enviar
                    </Button>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </FModal>
  );
};
